export default __webpack_public_path__ + "assets/img/Segoe UI Italic.eb9dca895cf2de5deeda0ab80d2123e2.woff";